import { SitesBuilderLibComponent, Navigation } from '@3ddv/ngx-sites-builder-lib';
import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToolsService } from '../services/tools.service';
import { Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-sbeditor-tool-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {
  private subscriptions: Array<Subscription>;
  public tool: Navigation;
  @Output() exportTool = new EventEmitter<Navigation>();

  constructor(private toolsService: ToolsService) {
    this.subscriptions = [];
  }

  ngOnInit(): void {
    const tools$ = this.toolsService.getAsyncTools$().subscribe(res=>{
      if(res.navigation){
        this.tool = JSON.parse(JSON.stringify(res.navigation));
      }else{
        console.error("navigation tool not found");
        return;
      }

    });
    this.subscriptions.push(tools$);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o=>o.unsubscribe());
  }
  onSelect($event): void{
    this.exportTool.emit(this.tool);
  }

}
